import React, { useState,useEffect } from 'react'
import firebase from '../../../firebase'
import moment from 'moment'

const Item = (props) => {
    const { data } = props

    return (
        <tr>
            <td>{moment(data.timestamp).format('DD-MM-YYYY')}</td>
            <td>{data.materialCode}</td>
            <td>{data.materialName} {data.materialDescription}</td>
            <td>{data.quantityIn}</td>
            <td>{data.quantityOut}</td>
            <td>{data.umIn}</td>
            <td>{data.umOut}</td>
        </tr>
    )
}

const ProductionMpContainer = (props) => {

    const [moves,setMoves] = useState([])

    useEffect(() => {
        const initialMonth = moment(props.month,'MM-YYYY').startOf('month').valueOf()
        const endMonth = moment(props.month,'MM-YYYY').endOf('month').valueOf()
        
        if (initialMonth && endMonth) {
            firebase.getCollectionRealTime('moves').where('type','==','material-presentations').where('timestamp','<=',endMonth).where('timestamp','>=',initialMonth).orderBy('timestamp','desc').onSnapshot(snap => {
                const data = snap.docs.map(doc => doc.data())
                setMoves(data)
            })
        }
    },[props.month])
    
    return (
        <tbody>{
            Object.keys(moves).map(key => <Item key={key} data={moves[key]} />)
        }</tbody>
    )
}

const ProductionMp = () => {

    const [month,setMonth] = useState(undefined)

    useEffect(() => {
        const current = moment().format('MM-YYYY')
        setMonth(current)
    }, [])

    return (
        <div className="production-moves">
            <table>
                <thead>
                    <tr>
                        <th colSpan="7">
                            <div className="date-picker">
                                <button onClick={prevMonth}>
                                    <i className="material-icons">arrow_left</i>
                                </button>
                                <span>{month}</span>
                                <button onClick={nextMonth}>
                                    <i className="material-icons">arrow_right</i>
                                </button>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th rowSpan="2">Fecha</th>
                        <th rowSpan="2">Código</th>
                        <th rowSpan="2">Nombre</th>
                        <th colSpan="2">Cantidad</th>
                        <th colSpan="2">Kg</th>
                    </tr>
                    <tr>
                        <th>Entrada</th>
                        <th>Salida</th>
                        <th>Entrada</th>
                        <th>Salida</th>
                    </tr>
                </thead>
                <ProductionMpContainer month={month} />
            </table>
        </div>
    )

    async function nextMonth() {
        try {
            const newMonth = moment(month, 'MM-YYYY').add(1,'month').format('MM-YYYY')
            setMonth(newMonth)
        } catch (error) {
            alert(error.message)
        }
    }
    async function prevMonth() {
        try {
            const newMonth = moment(month, 'MM-YYYY').subtract(1,'month').format('MM-YYYY')
            setMonth(newMonth)
        } catch (error) {
            alert(error.message)
        }
    }
}

export default ProductionMp